<template>
    <div id="map" :style="`width: 100%; height: ${height}px`" />
</template>

<script>
export default {
    name: "NaverMap",
    props: {
        height: { type: String, default: 516 },
    },
    mounted() {
        this.initMap();
    },
    methods: {
        initMap() {
            const center = new naver.maps.LatLng(37.236541, 126.872571);

            const map = new naver.maps.Map("map", {
                center,
                zoom: 19,
            });

            new naver.maps.Marker({
                position: center,
                map,
            });
        },
    },
};
</script>